'use client';

import { useTranslations } from 'next-intl';
import { FC } from 'react';
import { ModeToggle } from '@components/ModeToggle';
import LqdLogo from '../LqdLogo';
import Legal from './Legal';
import { navbarLinks } from './Navbar';

type FooterProps = {
  renderNavLinks?: boolean;
};

const Footer: FC<FooterProps> = ({ renderNavLinks = true }) => {
  const t = useTranslations('common');
  const navLinks = navbarLinks.map(link => (
    <li key={link.href}>
      <a href={link.href} className="mr-4 hover:underline md:mr-6 ">
        {link.name}
      </a>
    </li>
  ));

  return (
    <footer className="p-4 bg-background md:p-8 lg:p-10">
      <div className="max-w-screen-xl mx-auto text-center">
        <div className="flex justify-center mb-4">
          <div className="flex items-center gap-4">
            <LqdLogo />
          </div>
        </div>
        <p className="max-w-screen-md my-6 text-muted-foreground md:max-w-screen-sm">
          {t('tagline')}
        </p>
        {renderNavLinks && (
          <ul className="flex flex-wrap items-center justify-start gap-4 mb-6 text-foreground">
            {navLinks}
          </ul>
        )}
        <div className="flex items-center justify-between mt-6">
          <Legal />
          <ModeToggle />
        </div>
      </div>
    </footer>
  );
};

export default Footer;
